export const careerItems = {
  formerExperience: [
    "한국양성평등교육진흥원 성폭력예방교육 전문강사",
    "한신대학교 외래교수(법학)",
    "국민연금공단 자문변호사",
    "서울남부지방검찰청 형사상고심의위원회 위원",
    "서울특별시 금천구 아동친화도시 추진위원회 위원",
  ],
  currentExperience: [
    "예금보험공사 전담변호사",
    "법무부 중소기업법률지원단",
    "한국자산관리공사 고문변호사",
    "한국주택금융공사 소송위임변호사",
    "기술보증기금 소송위임변호사",
    "신용보증기금 소송위임변호사",
  ],
};

export const caseGroups = [
  {
    category: "마약사건",
    description: "마약류 범죄 수사·재판 대응",
    items: [
      "마약사건(밀수, 판매, 교부, 투약) 무죄, 집행유예, 벌금 성공사례 다수",
      "마약 재범 사건 벌금, 집행유예 성공사례 다수",
    ],
  },
  {
    category: "교통사고",
    description: "음주운전·도주 등 교통사고 대응",
    items: [
      "음주운전 3회 이상 집행유예, 벌금 성공사례 다수",
      "사고후미조치, 특가도주 중 무죄, 집행유예 성공사례 다수",
    ],
  },
  {
    category: "성범죄",
    description: "성범죄 수사·재판 대응",
    items: [
      "강간, 강제추행, 준강간 무죄 및 집행유예 성공사례 다수",
      "성범죄, 강제추행 사건 무혐의, 무죄, 집행유예 성공사례 다수",
    ],
  },
  {
    category: "소년범죄",
    description: "소년사건 선도·보호 절차",
    items: [
      "소년범죄 사건 불처분 결정 등 다수 진행",
    ],
  },
  {
    category: "부동산",
    description: "부동산 소송·분쟁 해결",
    items: [
      "전세사기를 비롯한 부동산 사기 사건 피해자 대리 다수 진행",
      "재개발·재건축 관련 소송 승소사례 다수",
      "지역주택조합 관련 소송 승소사례 다수",
      "유치권 관련 소송 승소사례 다수",
      "건축물 하자 소송 승소사례 다수",
      "지장물 철거 등 특수 부동산 소송 승소사례 다수",
      "소유권이전등기 말소 등 소유권 분쟁 승소사례 다수",
      "부동산 신탁 관련 분쟁 승소사례 다수",
      "사해행위 취소, 배당이의 사건 승소사례 다수",
    ],
  },
  {
    category: "경제범죄",
    description: "사기·횡령·배임 등 경제 범죄",
    items: [
      "보이스피싱 무죄, 집행유예 성공사례 다수",
      "사기, 횡령, 배임 등 각종 재산범죄 무죄 성공사례 다수",
      "유사수신 사건 피해자 대리 다수 진행",
      "가상화폐 사건 피해자 대리 다수 진행",
    ],
  },
  {
    category: "가사/상속",
    description: "이혼·상속·가사 분쟁 해결",
    items: [
      "이혼 및 재산분할, 양육권 분쟁 조정·소송 승소사례 다수",
      "상속회복청구, 유류분반환 소송 승소사례 다수",
      "상속재산분할 심판·조정 진행 다수",
    ],
  },
];

export const broadcastItems = [
  {
    title: "실화탐사대 자문 인터뷰",
    subtitle: "실화탐사대",
    description: "MBC 실화탐사대 프로그램에 마약 및 형사사건 전문가로 출연하여 사건 분석 및 법률 자문을 제공하였습니다.",
    videoUrl: "/images/int_m.mp4",
    thumbnail: "/images/pic_m.png",
  },
  {
    title: "뉴스토리 자문 인터뷰",
    subtitle: "뉴스토리",
    description: "뉴스토리 프로그램에 마약전문변호사로 출연하여 마약 관련 형사사건에 대한 심층 법률 해설을 제공하였습니다.",
    videoUrl: "/images/int_s.mp4",
    thumbnail: "/images/pic_s.png",
  },
  {
    title: "MBC뉴스 자문 인터뷰",
    subtitle: "MBC뉴스",
    description: "MBC 뉴스에 형사사건 및 마약류 관련 법률 전문가로 출연하여 시청자들에게 정확하고 신뢰할 수 있는 법률 정보를 전달하였습니다.",
    videoUrl: "",
    thumbnail: "/images/pic_m2.webp",
  },
];

export const pressItems = [
  {
    outlet: "조선일보",
    title: "전체 변호사 4명뿐인 효민, 80억원대 대출금 소송서 태평양-율촌 연합군 물리쳐",
    url: "https://www.chosun.com/site/data/html_dir/2017/01/09/2017010902038.html",
    thumbnail: "https://www.chosun.com/resizer/v2/45BB7WYDB4F3OU7IDUMTRIWVIE.jpg?auth=82c860bc8baf26b693c38cf1360315d0b18eef9e58e4694d9929833731596179&width=258&height=135&smart=true",
  },
  {
    outlet: "한국경제TV",
    title: '"집주인이 바빠서요"…중개사 말만 믿었다가는 [우동집 인터뷰]',
    url: "https://www.wowtv.co.kr/NewsCenter/News/Read?articleId=A202504030342&t=NN",
    thumbnail: "https://img.wowtv.co.kr/wowtv_news/dnrs/20250404/B20250404095907850.jpg",
  },
  {
    outlet: "로이슈",
    title: "전세사기 피해 커지기 전 전문가조언 받아 대응해야",
    url: "https://lawissue.co.kr/view.php?ud=2025080511024861536cf2d78c68_12",
    thumbnail: "https://cliimage.commutil.kr/phpwas/restmb_allidxmake.php?pp=002&idx=999&simg=20250805110322023806cf2d78c6821123419777.jpg&nmt=12",
  },
  {
    outlet: "미디어파인",
    title: "전세보증금 돌려받지 못했다면? 보증금반환소송으로 권리 지켜야 [이승환 변호사 칼럼]",
    url: "https://www.mediafine.co.kr/news/articleView.html?idxno=80624",
    thumbnail: "https://cdn.mediafine.co.kr/news/photo/202606/80624_117310_51.jpg",
  },
  {
    outlet: "경상일보",
    title: "주택, 상가 월세미납 명도소송 언제 시작하는게 좋을까?",
    url: "https://www.ksilbo.co.kr/news/articleView.html?idxno=1056371",
    thumbnail: "https://cdn.ksilbo.co.kr/news/thumbnail/202605/1056371_636416_727_v150.jpg",
  },
  {
    outlet: "경상일보",
    title: "[법률칼럼] 부동산 명도소송에서 강제퇴거까지",
    url: "https://www.ksilbo.co.kr/news/articleView.html?idxno=1052888",
    thumbnail: "https://cdn.ksilbo.co.kr/news/thumbnail/202604/1052888_633545_051_v150.jpg",
  },
];

export const caseBoardMockData = [
  {
    id: "1",
    title: "음주운전 3회 차량 4대 손상 사건 - 벌금형 성공",
    category: "교통사고",
    content: "의뢰인은 음주운전 3회 전력이 있었으며, 이번 사건에서 차량 4대를 손상시키는 중대한 사고를 발생시켰습니다. 검찰은 징역형을 구형하였으나, 사고 경위의 세밀한 분석과 적극적인 피해 합의 노력을 통해 벌금형을 이끌어내는 데 성공하였습니다.\n\n특히 사고 직후 의뢰인이 취한 신속한 현장 조치와 피해 차량 전부에 대한 수리비 전액 보상, 피해자들과의 원만한 합의가 양형에 크게 유리하게 작용하였습니다. 여기에 음주운전 재범 방지를 위한 치료 프로그램 이수 의지를 적극 소명하여 재범 가능성을 낮게 평가받은 점도 중요한 요소로 반영되었습니다. 결과적으로 실형 대신 벌금형과 보호관찰이라는 최선의 결과를 얻어낼 수 있었습니다.",
    date: "2026-03-15",
    image: " ",
    documents: [" "],
  },
  {
    id: "2",
    title: "전세사기 피해자 대리 소송 - 전액 배상 승소",
    category: "부동산",
    content: "전세보증금 3억 원을 반환받지 못한 피해자를 대리하여 임대인 및 보증금 반환 책임이 있는 제3자에 대해 소송을 제기하였습니다. 부동산 관련 법리의 깊은 이해와 실무 노하우를 바탕으로 전액 배상 판결을 이끌어내는 데 성공하였습니다.\n\n임대차계약 종료 이후에도 보증금 반환이 이뤄지지 않는 전형적인 전세사기 사안으로, 저희는 임대인의 무자력 가능성에 대비해 공인중개사와 보증기관의 책임까지 폭넓게 검토하며 소송 전략을 수립했습니다. 다수의 관련 판례를 면밀히 분석하고 임대차관계의 실제와 보증금 반환 의무의 성립 시점을 정밀하게 입증하여, 법원으로부터 전액 배상과 지연손해금까지 인정받는 판결을 이끌어냈습니다.",
    date: "2026-01-20",
    image: " ",
    documents: [" "],
  },
  {
    id: "3",
    title: "마약 대마 투약 혐의 - 무죄 판결",
    category: "마약사건",
    content: "의뢰인은 대마 투약 혐의로 기소되었으나, 압수수색의 절차적 위법성과 증거능력 문제를 집중적으로 주장하였습니다. 수사기관의 증거 수집 과정의 위법성을 적극적으로 다투어 1심에서 무죄 판결을 이끌어내는 데 성공하였습니다.\n\n특히 본건에서는 영장에 기재된 압수 범위를 벗어난 증거 수집이 있었고, 피의자신문 과정에서의 진술 임의성에도 중대한 의문이 있었습니다. 저희는 수사기관의 증거 수집 절차 전반을 시간대별로 재구성하여 위법수집증거 배제 법칙의 적용을 주장하였고, 법원이 이를 받아들여 핵심 증거의 증거능력을 배제함으로써 무죄 판결이 선고되었습니다.",
    date: "2025-11-08",
    image: " ",
    documents: [" "],
  },
  {
    id: "4",
    title: "성범죄 무혐의 처분 - 사실관계 재구성 성공",
    category: "성범죄",
    content: "의뢰인은 강제추행 혐의로 피소되었으나, 면밀한 사실관계 확인과 사건 현장의 재구성을 통해 억울한 혐의임을 입증하였습니다. 수사 단계에서 적극적으로 변론하여 무혐의 처분을 받아내는 데 성공하였습니다.\n\n저희는 사건 당시의 CCTV와 목격자 진술, 통신 기록 등을 종합적으로 분석하여 고소인의 진술과 객관적 사실 사이의 모순점을 치밀하게 정리했습니다. 현장 구조와 동선을 재구성한 자료를 수사기관에 제출하고 의뢰인에 대한 사실관계를 적극 소명함으로써, 기소되기도 전에 무혐의 처분을 받아낼 수 있었습니다.",
    date: "2025-09-03",
    image: " ",
    documents: [" "],
  },
  {
    id: "5",
    title: "재개발 조합원 자격 분쟁 - 승소",
    category: "부동산",
    content: "서울시 관내 재개발 조합의 조합원 자격 분쟁 사건에서, 관련 조례와 최신 판례 동향을 철저히 분석하여 의뢰인의 조합원 자격을 인정받는 판결을 이끌어냈습니다. 재개발·재건축 관련 법리의 전문성을 바탕으로 한 결과였습니다.\n\n조합 측은 의뢰인의 조합원 지위를 부인하며 분양 대상에서 제외하려 했으나, 저희는 도시정비법상 조합원 자격 요건과 해당 조합 정관의 해석, 그리고 과거 정비사업 유사 사례의 판례를 종합적으로 검토했습니다. 의뢰인의 권리 행사 내역과 주민등록·거주 이력 등을 체계적으로 입증하여, 법원으로부터 조합원 자격을 인정받고 조합 측의 제외 처분이 무효임을 확인받는 판결을 이끌어냈습니다.",
    date: "2025-07-12",
    image: " ",
    documents: [" "],
  },
];